import 'jquery/src/jquery';
//import 'bootstrap/dist/js/bootstrap';

//import 'bootstrap/dist/css/bootstrap.css';
//import 'bootstrap/dist/css/bootstrap-theme.css';

import '../favicon.ico';

// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...




// WEBPACK FOOTER //
// ./angularApp/vendor.ts